"use client";

import { useState } from "react";

type IntakeFormData = {
  symptoms?: string;
  medicalHistory?: string;
  medications?: string;
  allergies?: string;
};

type IntakeFormProps = {
  value?: IntakeFormData;
  onChange: (data: IntakeFormData) => void;
  required?: boolean;
  error?: string;
};

export function IntakeForm({ value = {}, onChange, required, error }: IntakeFormProps) {
  const [formData, setFormData] = useState(value);

  const handleChange = (field: string, val: string) => {
    const updated = { ...formData, [field]: val };
    setFormData(updated);
    onChange(updated);
  };

  return (
    <div className="space-y-4 rounded-md border p-4">
      <h3 className="text-sm font-medium">
        Medical Information {required && <span className="text-destructive">*</span>}
      </h3>
      <div>
        <label className="block text-sm font-medium mb-1">Symptoms / Reason for visit</label>
        <textarea
          value={formData.symptoms || ""}
          onChange={(e) => handleChange("symptoms", e.target.value)}
          rows={3}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          placeholder="Please describe your symptoms or reason for this appointment"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Medical History</label>
        <textarea
          value={formData.medicalHistory || ""}
          onChange={(e) => handleChange("medicalHistory", e.target.value)}
          rows={2}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          placeholder="Any relevant medical history"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Current Medications</label>
        <input
          type="text"
          value={formData.medications || ""}
          onChange={(e) => handleChange("medications", e.target.value)}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          placeholder="List any current medications"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Allergies</label>
        <input
          type="text"
          value={formData.allergies || ""}
          onChange={(e) => handleChange("allergies", e.target.value)}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          placeholder="Any known allergies"
        />
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
